import React, { useState, useEffect, useRef } from "react";
import "../styles/EDCCForm.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import heroBg from "../assets/images/HeroBanner.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { shortenFileName } from "../utils/shortenFileName";
const RegistrationForm = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASEURL;
  const inputRefs = useRef({}); // Store refs for all input fields
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    Password: "",
    confirm_password: "",
    name_of_organization: "",
    year_of_establishment: "",
    name_of_partner: "",
    legal_status: "",
    website_url: "",
    gst_number: "",
    pan_number: "",
    name_certificate: "",
    certificate_address: "Office Address",
    contact_office: "",
    mobile_number: "",
    toll_free_number: "",
    flat_house_building: "",
    colony_street_locality: "",
    landmark: "",
    country: "",
    state: "",
    district: "",
    pincode: "",
    co_flat_house_building: "",
    Co_colony_street_locality: "",
    co_landmark: "",
    Co_country: "",
    Co_state: "",
    Co_district: "",
    Co_pincode: "",
    address_to_be_printed_on_certificate: "",
    range_of_products: [],
    others_products: "",
    plot: "",
    production_shed: "",
    total_area: "",
    administartive_area: "",
    domestic_commercial: "",
    power_load: "",
    certificate_issued: "",
    available_certificate: "",
    annual_turnover: "",
    details_of_machineries: null,
    date_application: "",
    name: "",
    designation: "",
    upload_signature: null,
    company_seal: null,
    note: [],
    electricity_bill: null,
    lease_agreement: null,
    gst_certificate: null,
    pan_certificate: null,
    acknowledgement_certificate: null,
    unit_registration_certificate: null,
    list_of_machines: null,
    copy_certificates: null,
    ca_certificate: null,
    affidavit: null,
    signed_letter_head: null,
    is_rejected: false,
    rejection_details: {},
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [coStates, setCoStates] = useState([]);
  const [coDistricts, setCoDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [subItemInputs, setSubItemInputs] = useState({});

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        console.log("Fetching countries...");
        const response = await axios.get(`${baseUrl}/countries`);
        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          setCountries(response.data.data);
          console.log("Countries fetched:", response.data.data);
        } else {
          console.error("Invalid countries response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, [baseUrl]);

  useEffect(() => {
    const fetchStates = async () => {
      if (!formData.country) {
        console.log("No country selected, clearing states and districts");
        setStates([]);
        setDistricts([]);
        return;
      }
      try {
        console.log("Fetching states for country:", formData.country);
        const response = await axios.get(
          `${baseUrl}/states/${formData.country}`,
        );
        console.log("States API response:", response.data);

        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          setStates(response.data.data);
          console.log("States set:", response.data.data);
        } else if (Array.isArray(response.data)) {
          setStates(response.data);
          console.log("States set (direct array):", response.data);
        } else {
          console.error("Invalid states response format:", response.data);
          setStates([]);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
        console.error("Error details:", error.response || error.message);
        setStates([]);
      }
    };
    fetchStates();
  }, [formData.country, baseUrl]);

  useEffect(() => {
    const fetchDistricts = async () => {
      if (!formData.country || !formData.state) {
        console.log("Missing country or state, clearing districts");
        setDistricts([]);
        return;
      }
      try {
        console.log(
          "Fetching districts for country:",
          formData.country,
          "state:",
          formData.state,
        );
        const response = await axios.get(
          `${baseUrl}/districts/${formData.country}/${formData.state}`,
        );
        console.log("Districts API response:", response.data);

        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          setDistricts(response.data.data);
          console.log("Districts set:", response.data.data);
        } else if (Array.isArray(response.data)) {
          setDistricts(response.data);
          console.log("Districts set (direct array):", response.data);
        } else {
          console.error("Invalid districts response format:", response.data);
          setDistricts([]);
        }
      } catch (error) {
        console.error("Error fetching districts:", error);
        console.error("Error details:", error.response || error.message);
        setDistricts([]);
      }
    };
    fetchDistricts();
  }, [formData.state, formData.country, baseUrl]);

  useEffect(() => {
    const fetchCoStates = async () => {
      if (!formData.Co_country) {
        setCoStates([]);
        setCoDistricts([]);
        return;
      }
      try {
        console.log(
          "Fetching correspondence states for country:",
          formData.Co_country,
        );
        const response = await axios.get(
          `${baseUrl}/states/${formData.Co_country}`,
        );
        if (
          response.data &&
          (Array.isArray(response.data) ||
            (response.data.data && Array.isArray(response.data.data)))
        ) {
          const statesData = Array.isArray(response.data)
            ? response.data
            : response.data.data;
          setCoStates(statesData);
          console.log("Correspondence states fetched:", statesData);
        } else {
          console.error(
            "Invalid correspondence states response:",
            response.data,
          );
        }
      } catch (error) {
        console.error("Error fetching correspondence states:", error);
      }
    };
    fetchCoStates();
  }, [formData.Co_country, baseUrl]);

  useEffect(() => {
    const fetchCoDistricts = async () => {
      if (!formData.Co_country || !formData.Co_state) {
        setCoDistricts([]);
        return;
      }
      try {
        console.log(
          "Fetching correspondence districts for country:",
          formData.Co_country,
          "state:",
          formData.Co_state,
        );
        const response = await axios.get(
          `${baseUrl}/districts/${formData.Co_country}/${formData.Co_state}`,
        );
        if (
          response.data &&
          (Array.isArray(response.data) ||
            (response.data.data && Array.isArray(response.data.data)))
        ) {
          const districtsData = Array.isArray(response.data)
            ? response.data
            : response.data.data;
          setCoDistricts(districtsData);
          console.log("Correspondence districts fetched:", districtsData);
        } else {
          console.error(
            "Invalid correspondence districts response:",
            response.data,
          );
        }
      } catch (error) {
        console.error("Error fetching correspondence districts:", error);
      }
    };
    fetchCoDistricts();
  }, [formData.Co_state, formData.Co_country, baseUrl]);

  const handleLogin = () => {
    navigate("/edcc-login");
  };
  const handleMemberLogin = () => {
    navigate("/member-login");
  };
  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    let error = "";

    // Real-time validation
    switch (name) {
      case "email":
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Invalid email format (must include @domain.com)";
        }
        break;

      case "Password":
        if (value && value.length < 8) {
          error = "Password must be at least 8 characters long";
        } else if (
          value &&
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
            value,
          )
        ) {
          error =
            "Password must contain uppercase, lowercase, number and special character";
        }
        break;

      case "confirm_password":
        if (value && value !== formData.Password) {
          error = "Passwords do not match";
        }
        break;

      case "name_of_organization":
      case "name_of_partner":
      case "name_certificate":
      case "contact_office":
      case "name":
        // Allow only alphabets, spaces, dots, and common punctuation
        if (value && !/^[A-Za-z\s.,'-]+$/.test(value)) {
          error = "Only alphabets, spaces and common punctuation allowed";
        }
        break;

      case "gst_number":
        // GST format: 2 digits state code + 10 alphanumeric PAN + 1 digit entity code + 1 digit Z + 1 check digit
        if (
          value &&
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
            value,
          )
        ) {
          error = "Invalid GST format (e.g., 22AAAAA0000A1Z5)";
        }
        break;

      case "pan_number":
        if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
          error = "Invalid PAN format (e.g., ABCDE1234F)";
        }
        break;

      case "mobile_number":
        // Remove any non-digit characters for processing
        processedValue = value.replace(/\D/g, "");
        if (processedValue && processedValue.length !== 10) {
          error = "Mobile number must be exactly 10 digits";
        } else if (processedValue && !/^[6-9]/.test(processedValue)) {
          error = "Mobile number must start with 6, 7, 8, or 9";
        }
        break;

      case "pincode":
      case "Co_pincode":
        // Allow only 6 digits
        processedValue = value.replace(/\D/g, "");
        if (processedValue && processedValue.length !== 6) {
          error = "Pincode must be exactly 6 digits";
        }
        break;

      case "plot":
      case "production_shed":
      case "total_area":
      case "administartive_area":
        // Allow only numbers and decimal points
        if (value && !/^\d+(\.\d+)?$/.test(value)) {
          error = "Only numbers allowed for area (Sq. Ft)";
        }
        break;

      case "domestic_commercial":
        const validPowerTypes = ["domestic", "commercial", "industrial"];
        if (value && !validPowerTypes.includes(value.toLowerCase())) {
          error = "Must be Domestic, Commercial, or Industrial";
        }
        break;

      case "power_load":
        if (value && !/^\d+(\.\d+)?\s*(kW|kVA|KW|KVA)$/i.test(value)) {
          error = "Enter power load with unit (e.g., 100 kW or 150 kVA)";
        }
        break;

      case "available_certificate":
        // Allow only alphabets, numbers, spaces, commas, and common punctuation
        if (value && !/^[A-Za-z0-9\s,.\-()&]+$/.test(value)) {
          error = "Invalid characters in certificate names";
        }
        break;

      case "annual_turnover":
        // Allow only numbers, commas, and currency symbols
        if (value && !/^[\d,.\s₹$]+$/.test(value)) {
          error = "Only numbers and currency symbols allowed";
        }
        break;

      // case "website_url":
      //   if (
      //     value &&
      //     !/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/.test(value)
      //   ) {
      //     error = "Invalid URL format (must start with http:// or https://)";
      //   }
      //   break;
    }

    setFormData((prev) => {
      const newState = { ...prev, [name]: processedValue };

      if (name === "country") {
        newState.state = "";
        newState.district = "";
      } else if (name === "state") {
        newState.district = "";
      } else if (name === "Co_country") {
        newState.Co_state = "";
        newState.Co_district = "";
      } else if (name === "Co_state") {
        newState.Co_district = "";
      }

      return newState;
    });

    // Set or clear error for this field
    setErrors((prev) => ({ ...prev, [name]: error }));
  };
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setErrors((prev) => ({
          ...prev,
          [field]: "Only PDF files are allowed",
        }));
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        // Updated to 10MB
        setErrors((prev) => ({
          ...prev,
          [field]: "File size must not exceed 10MB",
        }));
        return;
      }
    }
    setFormData((prev) => ({ ...prev, [field]: file }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const productMapping = {
    "Seating System (Office, Visitor, Lounge chairs, Auditorium, Executive Chair Ranges & Sofas Certification Fee: 1,00,000.00)":
      {
        heading: "Seating System",
        price: 100000,
      },
    "Office Furniture (Office Desks, Executive Tables Storage (Side & Back Units), Workstation Certification Fee: 1,50,000.00)":
      {
        heading: "Office Furniture",
        price: 150000,
      },
    "Healthcare Furniture (Bed Side Screen, Cabinet with Drawers & Bed Side Lockers, Examination Table, ICU Beds, Fowler Beds, Hospital Chairs, Benches & Stools, Wheelchair Certification Fee: 1,00,000.00)":
      {
        heading: "Healthcare Furniture",
        price: 100000,
      },
    "Storage Furniture (Steel & wooden racks, Cabinets and Almirah with or without sliding & swing doors, Drawer Storage, Locker and Compactor storage systems etc. Certification Fee: 1,00,000.00)":
      {
        heading: "Storage Furniture",
        price: 100000,
      },
    "Modular Furniture (Sliding wardrobes, walk-in wardrobes, beds with storage, modular study tables, modular display units, and modular entertainment units Certification Fee: 1,00,000.00)":
      {
        heading: "Modular Furniture",
        price: 100000,
      },
  };

  const handleCheckboxChange = (e) => {
    const { checked, value } = e.target;

    if (e.target.name === "range_of_products") {
      const product =
        productMapping[value] ||
        [
          {
            heading: "Classroom Furniture",
            label:
              "Classroom furniture(Desk & Seating for different age groups, Teacher's Table and Storage, Certification Fee : 1,00,000.00)",
            price: 100000,
          },
          {
            heading: "Institutional Furniture",
            label:
              "Institutional Furniture( Library, Chemical laboratory & Hostel, Office Desks, Seating System, auditorium, Executive Tables,Board Room, Workstation. Certification Fee : 1,50,000.00)",
            price: 150000,
          },
          {
            heading: "Classroom and Institutional furniture range",
            label:
              "Classroom and Institutional furniture range(Desk & Seating for different age groups, Teacher's Table and Storage, Library, Chemical laboratory & Hostel, Office Desks, Seating System, auditorium, Executive Tables,Board Room, Workstation. Certification Fee : 2,50,000.00)",
            price: 250000,
          },
        ].find((p) => p.label === value);

      console.log("Product checkbox changed:", { value, checked, product });

      setFormData((prev) => {
        const currentProducts = Array.isArray(prev.range_of_products)
          ? prev.range_of_products
          : [];

        if (checked && product) {
          console.log("Adding product:", product);
          return {
            ...prev,
            range_of_products: [
              ...currentProducts,
              { ...product, sub_items: [] },
            ],
          };
        } else if (product) {
          console.log("Removing product:", product);
          return {
            ...prev,
            range_of_products: currentProducts.filter(
              (p) => p && p.heading !== product.heading,
            ),
          };
        }
        return prev;
      });
      setErrors((prev) => ({ ...prev, range_of_products: "" }));
    }
  };

  const addSubItem = (heading) => {
    const val = subItemInputs[heading];
    if (!val || !val.trim()) return;
    setFormData((prev) => ({
      ...prev,
      range_of_products: prev.range_of_products.map((p) =>
        p.heading === heading
          ? { ...p, sub_items: [...(p.sub_items || []), val.trim()] }
          : p,
      ),
    }));
    setSubItemInputs((prev) => ({ ...prev, [heading]: "" }));
  };

  const removeSubItem = (heading, subIndex) => {
    setFormData((prev) => ({
      ...prev,
      range_of_products: prev.range_of_products.map((p) =>
        p.heading === heading
          ? {
              ...p,
              sub_items: p.sub_items.filter((_, i) => i !== subIndex),
            }
          : p,
      ),
    }));
  };

  const handleNoteChange = (e) => {
    const { checked, value } = e.target;
    console.log("Note checkbox changed:", { value, checked });

    setFormData((prev) => {
      if (checked) {
        return {
          ...prev,
          note: [...prev.note, value],
        };
      } else {
        return {
          ...prev,
          note: prev.note.filter((n) => n !== value),
        };
      }
    });
    setErrors((prev) => ({ ...prev, note: "" }));
  };

  const validateForm = () => {
    console.log("Validating form...");
    const newErrors = {};
    const validHeadings = [
      "Seating System",
      "Office Furniture",
      "Healthcare Furniture",
      "Storage Furniture",
      "Modular Furniture",
      "Classroom Furniture",
      "Institutional Furniture",
      "Classroom and Institutional furniture range",
    ];

    // Enhanced field validations
    const requiredFields = [
      {
        field: "email",
        message: "Email is required",
        validate: (value) => {
          if (!value) return "Email is required";
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
            return "Invalid email format (must include @domain.com)";
          return null;
        },
      },
      {
        field: "Password",
        message: "Password is required",
        validate: (value) => {
          if (!value) return "Password is required";
          if (value.length < 8)
            return "Password must be at least 8 characters long";
          if (
            !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
              value,
            )
          ) {
            return "Password must contain uppercase, lowercase, number and special character";
          }
          return null;
        },
      },
      {
        field: "confirm_password",
        message: "Confirm password is required",
        validate: (value) => {
          if (!value) return "Confirm password is required";
          if (value !== formData.Password) return "Passwords do not match";
          return null;
        },
      },
      {
        field: "name_of_organization",
        message: "Organization name is required",
        validate: (value) => {
          if (!value) return "Organization name is required";
          if (!/^[A-Za-z\s.,'-]+$/.test(value))
            return "Only alphabets, spaces and common punctuation allowed";
          return null;
        },
      },
      {
        field: "year_of_establishment",
        message: "Year of establishment is required",
        validate: (value) => {
          if (!value) return "Year of establishment is required";

          const year = parseInt(value, 10);
          const currentYear = new Date().getFullYear();

          // Must be 4 digits
          if (!/^\d{4}$/.test(value)) return "Year must be a 4-digit number";

          // Must be within valid range
          if (year < 1800 || year > currentYear)
            return `Year must be between 1800 and ${currentYear}`;

          return null;
        },
      },

      {
        field: "name_of_partner",
        message: "Name of partner is required",
        validate: (value) => {
          if (!value) return "Name of partner is required";
          if (!/^[A-Za-z\s.,'-]+$/.test(value))
            return "Only alphabets, spaces and common punctuation allowed";
          return null;
        },
      },
      { field: "legal_status", message: "Legal status is required" },
      {
        field: "website_url",
        message: "Website URL is required",
        validate: (value) => {
          if (!value) return "Website URL is required";
          // if (
          //   !/^https?:\/\/(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/.test(
          //     value,
          //   )
          // ) {
          //   return "Invalid URL format (must start with http:// or https://)";
          // }
          return null;
        },
      },
      {
        field: "gst_number",
        message: "GST number is required",
        validate: (value) => {
          if (!value) return "GST number is required";
          if (
            !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
              value,
            )
          ) {
            return "Invalid GST format (e.g., 22AAAAA0000A1Z5)";
          }
          return null;
        },
      },
      {
        field: "pan_number",
        message: "PAN number is required",
        validate: (value) => {
          if (!value) return "PAN number is required";
          if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
            return "Invalid PAN format (e.g., ABCDE1234F)";
          }
          return null;
        },
      },
      {
        field: "name_certificate",
        message: "Name on certificate is required",
        validate: (value) => {
          if (!value) return "Name on certificate is required";
          if (!/^[A-Za-z\s.,'-]+$/.test(value))
            return "Only alphabets, spaces and common punctuation allowed";
          return null;
        },
      },
      {
        field: "certificate_address",
        message: "Certificate address is required",
      },
      {
        field: "contact_office",
        message: "Contact person is required",
        validate: (value) => {
          if (!value) return "Contact person is required";
          if (!/^[A-Za-z\s.,'-]+$/.test(value))
            return "Only alphabets, spaces and common punctuation allowed";
          return null;
        },
      },
      {
        field: "mobile_number",
        message: "Mobile number is required",
        validate: (value) => {
          if (!value) return "Mobile number is required";
          const cleanValue = value.replace(/\D/g, "");
          if (cleanValue.length !== 10)
            return "Mobile number must be exactly 10 digits";
          if (!/^[6-9]/.test(cleanValue))
            return "Mobile number must start with 6, 7, 8, or 9";
          return null;
        },
      },
      { field: "flat_house_building", message: "Flat/House No is required" },
      { field: "colony_street_locality", message: "Colony/Street is required" },
      { field: "landmark", message: "Landmark is required" },
      { field: "country", message: "Country is required" },
      { field: "state", message: "State is required" },
      { field: "district", message: "District is required" },
      {
        field: "pincode",
        message: "Pincode is required",
        validate: (value) => {
          if (!value) return "Pincode is required";
          const cleanValue = value.replace(/\D/g, "");
          if (cleanValue.length !== 6)
            return "Pincode must be exactly 6 digits";
          return null;
        },
      },
      { field: "co_flat_house_building", message: "Flat/House No is required" },
      {
        field: "Co_colony_street_locality",
        message: "Colony/Street is required",
      },
      { field: "co_landmark", message: "Landmark is required" },
      { field: "Co_country", message: "Country is required" },
      { field: "Co_state", message: "State is required" },
      { field: "Co_district", message: "District is required" },
      {
        field: "Co_pincode",
        message: "Pincode is required",
        validate: (value) => {
          if (!value) return "Pincode is required";
          const cleanValue = value.replace(/\D/g, "");
          if (cleanValue.length !== 6)
            return "Pincode must be exactly 6 digits";
          return null;
        },
      },
      {
        field: "address_to_be_printed_on_certificate",
        message: "Address to be printed on Certificate is required",
      },
      {
        field: "plot",
        message: "Plot area is required",
        validate: (value) => {
          if (!value) return "Plot area is required";
          if (!/^\d+(\.\d+)?$/.test(value))
            return "Only numbers allowed for area (Sq. Ft)";
          return null;
        },
      },
      {
        field: "production_shed",
        message: "Production shed area is required",
        validate: (value) => {
          if (!value) return "Production shed area is required";
          if (!/^\d+(\.\d+)?$/.test(value))
            return "Only numbers allowed for area (Sq. Ft)";
          return null;
        },
      },
      {
        field: "total_area",
        message: "Total area is required",
        validate: (value) => {
          if (!value) return "Total area is required";
          if (!/^\d+(\.\d+)?$/.test(value))
            return "Only numbers allowed for area (Sq. Ft)";
          return null;
        },
      },
      {
        field: "administartive_area",
        message: "Administrative area is required",
        validate: (value) => {
          if (!value) return "Administrative area is required";
          if (!/^\d+(\.\d+)?$/.test(value))
            return "Only numbers allowed for area (Sq. Ft)";
          return null;
        },
      },
      {
        field: "domestic_commercial",
        message: "Power type is required",
        validate: (value) => {
          if (!value) return "Power type is required";
          const validTypes = ["domestic", "commercial", "industrial"];
          if (!validTypes.includes(value.toLowerCase())) {
            return "Must be Domestic, Commercial, or Industrial";
          }
          return null;
        },
      },
      {
        field: "power_load",
        message: "Power load is required",
        validate: (value) => {
          if (!value) return "Power load is required";
          if (!/^\d+(\.\d+)?\s*(kW|kVA|KW|KVA)$/i.test(value)) {
            return "Enter power load with unit (e.g., 100 kW or 150 kVA)";
          }
          return null;
        },
      },
      {
        field: "certificate_issued",
        message: "Certificate issued type is required",
      },
      {
        field: "available_certificate",
        message: "Available certificates are required",
        validate: (value) => {
          if (!value) return "Available certificates are required";
          if (!/^[A-Za-z0-9\s,.\-()&]+$/.test(value))
            return "Invalid characters in certificate names";
          return null;
        },
      },
      {
        field: "annual_turnover",
        message: "Annual turnover is required",
        validate: (value) => {
          if (!value) return "Annual turnover is required";
          if (!/^[\d,.\s₹$]+$/.test(value))
            return "Only numbers and currency symbols allowed";
          return null;
        },
      },
      {
        field: "details_of_machineries",
        message: "Machineries file is required",
      },
      { field: "date_application", message: "Date of application is required" },
      {
        field: "name",
        message: "Name is required",
        validate: (value) => {
          if (!value) return "Name is required";
          if (!/^[A-Za-z\s.,'-]+$/.test(value))
            return "Only alphabets, spaces and common punctuation allowed";
          return null;
        },
      },
      { field: "designation", message: "Designation is required" },
      { field: "upload_signature", message: "Signature file is required" },
      { field: "company_seal", message: "Company seal file is required" },
      { field: "lease_agreement", message: "Lease agreement file is required" },
      { field: "electricity_bill", message: "Electricity bill is required" },
      { field: "gst_certificate", message: "GST certificate is required" },
      { field: "pan_certificate", message: "PAN certificate is required" },
      {
        field: "acknowledgement_certificate",
        message: "Acknowledgement certificate is required",
      },
      {
        field: "unit_registration_certificate",
        message: "Unit registration certificate is required",
      },
      { field: "list_of_machines", message: "List of machines is required" },
      { field: "copy_certificates", message: "Certificates copy is required" },
      { field: "ca_certificate", message: "CA certificate is required" },

      {
        field: "range_of_products",
        message: "At least one product must be selected",
        validate: () => {
          if (formData.range_of_products.length === 0)
            return "At least one product must be selected";
          return null;
        },
      },
    ];

    requiredFields.forEach(({ field, message, validate }) => {
      if (validate) {
        const error = validate(formData[field]);
        if (error) {
          newErrors[field] = error;
        }
      } else if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        newErrors[field] = message;
      }
    });

    const invalidProducts = formData.range_of_products.filter(
      (p) => !validHeadings.includes(p.heading),
    );
    if (invalidProducts.length > 0) {
      newErrors.range_of_products = "Invalid product heading selected";
    }

    setErrors(newErrors);
    console.log("Validation errors:", newErrors);
    console.log("Form data during validation:", formData);

    // Highlight all empty fields and scroll to the first one
    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      if (inputRefs.current[firstErrorField]) {
        inputRefs.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        inputRefs.current[firstErrorField].focus();
      }
      // Ensure all empty fields are highlighted
      Object.keys(newErrors).forEach((field) => {
        if (inputRefs.current[field]) {
          inputRefs.current[field].classList.add("input-error");
        }
      });
    }
    // Update the error highlighting section in validateForm function:
    // Highlight all empty fields and scroll to the first one
    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];

      // Special handling for note field
      if (firstErrorField === "note") {
        if (inputRefs.current["note_0"]) {
          inputRefs.current["note_0"].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          inputRefs.current["note_0"].focus();
        }
      } else if (inputRefs.current[firstErrorField]) {
        inputRefs.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        inputRefs.current[firstErrorField].focus();
      }

      // Ensure all empty fields are highlighted
      Object.keys(newErrors).forEach((field) => {
        if (field === "note") {
          // Highlight all note checkboxes
          ["note_0", "note_1", "note_2"].forEach((noteField) => {
            if (inputRefs.current[noteField]) {
              inputRefs.current[noteField].classList.add("input-error");
            }
          });
        } else if (inputRefs.current[field]) {
          inputRefs.current[field].classList.add("input-error");
        }
      });
    }
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted. Form data:", formData);

    try {
      if (!validateForm()) {
        console.log("Validation failed. Stopping submission.");
        return;
      }

      console.log("Validation passed. Preparing to send API request...");
      setLoading(true);
      setApiError(null);

      const formDataToSend = new FormData();

      console.log("Building FormData...");
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          if (key === "note") {
            console.log("Appending notes individually:", value);
            value.forEach((note, index) => {
              formDataToSend.append(`note[${index}]`, note);
            });
          } else if (value instanceof File) {
            console.log(`Appending file for ${key}:`, value.name);
            formDataToSend.append(key, value);
          } else if (key === "range_of_products") {
            console.log("Appending range_of_products:", value);
            value.forEach((item, index) => {
              formDataToSend.append(
                `range_of_products[${index}][heading]`,
                item.heading,
              );
              formDataToSend.append(
                `range_of_products[${index}][price]`,
                item.price,
              );
              if (item.sub_items && Array.isArray(item.sub_items)) {
                item.sub_items.forEach((sub, subIdx) => {
                  formDataToSend.append(
                    `range_of_products[${index}][sub_items][${subIdx}]`,
                    sub,
                  );
                });
              }
            });
          } else if (Array.isArray(value)) {
            console.log(`Appending array for ${key}:`, value);
            value.forEach((item, index) =>
              formDataToSend.append(`${key}[${index}]`, item),
            );
          } else {
            console.log(`Appending ${key}:`, value);
            formDataToSend.append(key, value);
          }
        }
      });

      for (let [key, value] of formDataToSend.entries()) {
        console.log(`FormData entry: ${key} =`, value);
      }

      if (formData.is_rejected && !formData.rejection_details?.rejected_step) {
        console.log(
          "Appending default rejection_details[rejected_step]: docVerification",
        );
        formDataToSend.append(
          "rejection_details[rejected_step]",
          "docVerification",
        );
      }

      console.log("Sending API request to:", `${baseUrl}/createEdcc`);
      const response = await axios.post(
        `${baseUrl}/createEdcc`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      console.log("API response:", response.data);
      if (response.data && response.data.success) {
        console.log("Submission successful. Navigating to /edcc-login");
        navigate("/edcc-login");
      } else {
        setApiError(response.data.message || "Failed to submit form");
        console.error("API error:", response.data.message);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      setApiError(
        error.response?.data?.message ||
          "An error occurred while submitting the form",
      );
    } finally {
      setLoading(false);
      console.log("Submission process completed. Loading set to false.");
    }
  };

  return (
    <>
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
          </div>
        </div>
      </section>

      <div className="scrollable-content-home">
        <div className="content-container">
          <div className="content">
            <h2>AIOTA's Ergonomic Certification Registration Form</h2>
            {apiError && <div className="error-message">{apiError}</div>}

            <form onSubmit={handleSubmit} noValidate>
              {/* 🔔 Global error message if validation fails */}
              {/* {Object.keys(errors).length > 0 && (
                <div className="global-error-alert">
                  Please correct the highlighted fields before proceeding.
                </div>
              )} */}
              <h3>Basic Info:</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    E-mail Address <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Your E-mail Address"
                    ref={(el) => (inputRefs.current.email = el)}
                    className={errors.email ? "input-error" : ""}
                    required
                  />
                  {errors.email && (
                    <span className="error">{errors.email}</span>
                  )}
                </div>
                <div className="form-group" style={{ position: "relative" }}>
                  <label>
                    Password <span className="required-asterisk">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="Password"
                      value={formData.Password}
                      onChange={handleInputChange}
                      placeholder="Enter Your Password"
                      ref={(el) => (inputRefs.current.Password = el)}
                      className={errors.Password ? "input-error" : ""}
                      required
                      style={{ paddingRight: "35px", width: "100%" }}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "black",
                      }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  {errors.Password && (
                    <span className="error">{errors.Password}</span>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div className="form-group" style={{ position: "relative" }}>
                  <label>
                    Confirm Password{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showConfirm ? "text" : "password"}
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleInputChange}
                      placeholder="Confirm Your Password"
                      ref={(el) => (inputRefs.current.confirm_password = el)}
                      className={errors.confirm_password ? "input-error" : ""}
                      required
                      style={{ paddingRight: "35px", width: "100%" }}
                    />
                    <span
                      onClick={() => setShowConfirm(!showConfirm)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "black",
                      }}
                    >
                      {showConfirm ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  {errors.confirm_password && (
                    <span className="error">{errors.confirm_password}</span>
                  )}
                </div>
              </div>

              <h3>Organization Info:</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Name of organization or Agency{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="name_of_organization"
                    value={formData.name_of_organization}
                    onChange={handleInputChange}
                    placeholder="Enter Name of Organization or Agency"
                    ref={(el) => (inputRefs.current.name_of_organization = el)}
                    className={errors.name_of_organization ? "input-error" : ""}
                    required
                  />
                  {errors.name_of_organization && (
                    <span className="error">{errors.name_of_organization}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Year of Establishment{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="number"
                    name="year_of_establishment"
                    value={formData.year_of_establishment}
                    onChange={handleInputChange}
                    placeholder="Enter Year (e.g. 2025)"
                    ref={(el) => (inputRefs.current.year_of_establishment = el)}
                    className={
                      errors.year_of_establishment ? "input-error" : ""
                    }
                    required
                    min="1800"
                    max={new Date().getFullYear()}
                    onInput={(e) => {
                      // Limit to 4 digits max
                      if (e.target.value.length > 4) {
                        e.target.value = e.target.value.slice(0, 4);
                      }
                    }}
                  />
                  {errors.year_of_establishment && (
                    <span className="error">
                      {errors.year_of_establishment}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    Name of Proprietary / Partners / Directors{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="name_of_partner"
                    value={formData.name_of_partner}
                    onChange={handleInputChange}
                    placeholder="Enter Name of Proprietary / Partners / Directors"
                    ref={(el) => (inputRefs.current.name_of_partner = el)}
                    className={errors.name_of_partner ? "input-error" : ""}
                    required
                  />
                  {errors.name_of_partner && (
                    <span className="error">{errors.name_of_partner}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    Legal Status of Firm / Unit / Company{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="legal_status"
                    value={formData.legal_status}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.legal_status = el)}
                    className={errors.legal_status ? "input-error" : ""}
                    required
                  >
                    <option value="">Choose Legal Status</option>
                    <option value="Proprietorship">Proprietorship</option>
                    <option value="Partnership">Partnership</option>
                    <option value="LLP">LLP</option>
                    <option value="Private Limited">Private Limited</option>
                    <option value="Public Limited">Public Limited</option>
                  </select>
                  {errors.legal_status && (
                    <span className="error">{errors.legal_status}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Company Web Site{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="url"
                    name="website_url"
                    value={formData.website_url}
                    onChange={handleInputChange}
                    placeholder="Enter Company Web Site URL"
                    ref={(el) => (inputRefs.current.website_url = el)}
                    className={errors.website_url ? "input-error" : ""}
                    required
                  />
                  {errors.website_url && (
                    <span className="error">{errors.website_url}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    GST Registration Number{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="gst_number"
                    value={formData.gst_number}
                    onChange={handleInputChange}
                    placeholder="Enter GST Registration Number"
                    ref={(el) => (inputRefs.current.gst_number = el)}
                    className={errors.gst_number ? "input-error" : ""}
                    required
                  />
                  {errors.gst_number && (
                    <span className="error">{errors.gst_number}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    PAN Number <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="pan_number"
                    value={formData.pan_number}
                    onChange={handleInputChange}
                    placeholder="Enter PAN Number"
                    ref={(el) => (inputRefs.current.pan_number = el)}
                    className={errors.pan_number ? "input-error" : ""}
                    required
                  />
                  {errors.pan_number && (
                    <span className="error">{errors.pan_number}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Name on Certificate{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="name_certificate"
                    value={formData.name_certificate}
                    onChange={handleInputChange}
                    placeholder="Enter the Name on Certificate"
                    ref={(el) => (inputRefs.current.name_certificate = el)}
                    className={errors.name_certificate ? "input-error" : ""}
                    required
                  />
                  {errors.name_certificate && (
                    <span className="error">{errors.name_certificate}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Address on Certificate (Office/Factory address){" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="certificate_address"
                    value={formData.certificate_address}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.certificate_address = el)}
                    className={errors.certificate_address ? "input-error" : ""}
                    required
                  >
                    <option value="Office Address">Office Address</option>
                    <option value="Factory Address">Factory Address</option>
                  </select>
                  {errors.certificate_address && (
                    <span className="error">{errors.certificate_address}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    Contact person with Office Position{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="contact_office"
                    value={formData.contact_office}
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    ref={(el) => (inputRefs.current.contact_office = el)}
                    className={errors.contact_office ? "input-error" : ""}
                    required
                  />
                  {errors.contact_office && (
                    <span className="error">{errors.contact_office}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Mobile Number <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleInputChange}
                    placeholder="Enter Your Mobile Number"
                    ref={(el) => (inputRefs.current.mobile_number = el)}
                    className={errors.mobile_number ? "input-error" : ""}
                    required
                  />
                  {errors.mobile_number && (
                    <span className="error">{errors.mobile_number}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Toll Free Number (if any)</label>
                  <input
                    type="text"
                    name="toll_free_number"
                    value={formData.toll_free_number}
                    onChange={handleInputChange}
                    placeholder="Enter Toll Free Number"
                    ref={(el) => (inputRefs.current.toll_free_number = el)}
                    className={errors.toll_free_number ? "input-error" : ""}
                  />
                  {errors.toll_free_number && (
                    <span className="error">{errors.toll_free_number}</span>
                  )}
                </div>
              </div>

              <h3 className="address-section">
                Office / Correspondence Address:
              </h3>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Flat/House No/ Floor/ Building{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="flat_house_building"
                    value={formData.flat_house_building}
                    onChange={handleInputChange}
                    placeholder="Enter Your Flat/House No/ Floor/ Building"
                    ref={(el) => (inputRefs.current.flat_house_building = el)}
                    className={errors.flat_house_building ? "input-error" : ""}
                    required
                  />
                  {errors.flat_house_building && (
                    <span className="error">{errors.flat_house_building}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Colony/Street/Locality{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="colony_street_locality"
                    value={formData.colony_street_locality}
                    onChange={handleInputChange}
                    placeholder="Enter Your Colony/Street/Locality"
                    ref={(el) =>
                      (inputRefs.current.colony_street_locality = el)
                    }
                    className={
                      errors.colony_street_locality ? "input-error" : ""
                    }
                    required
                  />
                  {errors.colony_street_locality && (
                    <span className="error">
                      {errors.colony_street_locality}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Landmark <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    placeholder="Enter Your Landmark"
                    ref={(el) => (inputRefs.current.landmark = el)}
                    className={errors.landmark ? "input-error" : ""}
                    required
                  />
                  {errors.landmark && (
                    <span className="error">{errors.landmark}</span>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Country <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.country = el)}
                    className={errors.country ? "input-error" : ""}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="error">{errors.country}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    State <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.state = el)}
                    className={errors.state ? "input-error" : ""}
                    required
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state._id} value={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                  {errors.state && (
                    <span className="error">{errors.state}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    District <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.district = el)}
                    className={errors.district ? "input-error" : ""}
                    required
                  >
                    <option value="">Select District</option>
                    {districts.map((district) => (
                      <option key={district._id} value={district._id}>
                        {district.district_name}
                      </option>
                    ))}
                  </select>
                  {errors.district && (
                    <span className="error">{errors.district}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Pincode <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="Enter Pincode"
                    ref={(el) => (inputRefs.current.pincode = el)}
                    className={errors.pincode ? "input-error" : ""}
                    required
                  />
                  {errors.pincode && (
                    <span className="error">{errors.pincode}</span>
                  )}
                </div>
              </div>

              <h3 className="address-section">Factory Address:</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Flat/House No/ Floor/ Building{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="co_flat_house_building"
                    value={formData.co_flat_house_building}
                    onChange={handleInputChange}
                    placeholder="Enter Your Flat/House No/ Floor/ Building"
                    ref={(el) =>
                      (inputRefs.current.co_flat_house_building = el)
                    }
                    className={
                      errors.co_flat_house_building ? "input-error" : ""
                    }
                    required
                  />
                  {errors.co_flat_house_building && (
                    <span className="error">
                      {errors.co_flat_house_building}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Colony/Street/Locality{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="Co_colony_street_locality"
                    value={formData.Co_colony_street_locality}
                    onChange={handleInputChange}
                    placeholder="Enter Your Colony/Street/Locality"
                    ref={(el) =>
                      (inputRefs.current.Co_colony_street_locality = el)
                    }
                    className={
                      errors.Co_colony_street_locality ? "input-error" : ""
                    }
                    required
                  />
                  {errors.Co_colony_street_locality && (
                    <span className="error">
                      {errors.Co_colony_street_locality}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Landmark <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="co_landmark"
                    value={formData.co_landmark}
                    onChange={handleInputChange}
                    placeholder="Enter Your Landmark"
                    ref={(el) => (inputRefs.current.co_landmark = el)}
                    className={errors.co_landmark ? "input-error" : ""}
                    required
                  />
                  {errors.co_landmark && (
                    <span className="error">{errors.co_landmark}</span>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Country <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="Co_country"
                    value={formData.Co_country}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.Co_country = el)}
                    className={errors.Co_country ? "input-error" : ""}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.Co_country && (
                    <span className="error">{errors.Co_country}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    State <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="Co_state"
                    value={formData.Co_state}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.Co_state = el)}
                    className={errors.Co_state ? "input-error" : ""}
                    required
                  >
                    <option value="">Select State</option>
                    {coStates.map((state) => (
                      <option key={state._id} value={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                  {errors.Co_state && (
                    <span className="error">{errors.Co_state}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    District <span className="required-asterisk">*</span>
                  </label>
                  <select
                    name="Co_district"
                    value={formData.Co_district}
                    onChange={handleInputChange}
                    ref={(el) => (inputRefs.current.Co_district = el)}
                    className={errors.Co_district ? "input-error" : ""}
                    required
                  >
                    <option value="">Select District</option>
                    {coDistricts.map((district) => (
                      <option key={district._id} value={district._id}>
                        {district.district_name}
                      </option>
                    ))}
                  </select>
                  {errors.Co_district && (
                    <span className="error">{errors.Co_district}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Pincode <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="Co_pincode"
                    value={formData.Co_pincode}
                    onChange={handleInputChange}
                    placeholder="Enter Pincode"
                    ref={(el) => (inputRefs.current.Co_pincode = el)}
                    className={errors.Co_pincode ? "input-error" : ""}
                    required
                  />
                  {errors.Co_pincode && (
                    <span className="error">{errors.Co_pincode}</span>
                  )}
                </div>
              </div>
              <div className="form-row">
                {/* Column 1 - Address to be printed */}
                <div className="form-group">
                  <label>
                    Address to be printed on Certificate{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="address_to_be_printed_on_certificate"
                    value={formData.address_to_be_printed_on_certificate}
                    onChange={handleInputChange}
                    placeholder="Enter Address"
                    ref={(el) =>
                      (inputRefs.current.address_to_be_printed_on_certificate =
                        el)
                    }
                    className={
                      errors.address_to_be_printed_on_certificate
                        ? "input-error"
                        : ""
                    }
                    required
                  />
                  {errors.address_to_be_printed_on_certificate && (
                    <span className="error">
                      {errors.address_to_be_printed_on_certificate}
                    </span>
                  )}
                </div>

                {/* Column 2 - Empty */}
                <div className="form-group"></div>

                {/* Column 3 - Empty */}
                <div className="form-group"></div>
              </div>

              {/* Range of products */}
              <h3>Range of Products:</h3>
              {errors.range_of_products && (
                <span className="error">{errors.range_of_products}</span>
              )}

              <div className="fee-notice">
                <p>
                  <strong>Important Fee Information:</strong>
                </p>
                <p>
                  • Registration Fee: ₹59,000 (includes 18% GST, non-refundable)
                </p>
                <p>• Inspection Fee: ₹30,000 per product category</p>
                <p>
                  • GST: 18% applicable on certification and inspection fees
                </p>
                <p className="warning">
                  Note: Registration fee is non-refundable once paid, even if
                  the registration process is cancelled.
                </p>
              </div>

              <h3>
                Furniture Category <span className="required-asterisk">*</span>
              </h3>
              <p
                style={{
                  color: "#d32f2f",
                  fontSize: "14.5px",
                  fontWeight: "500",
                  marginBottom: "15px",
                  fontStyle: "italic",
                }}
              >
                Note: The product range and categories you enter here will
                appear on the certificate as-is. Please review carefully before
                proceeding.
              </p>
              <div className="products-list">
                {[
                  {
                    heading: "Seating System",
                    label:
                      "Seating System (Office, Visitor, Lounge chairs, Auditorium, Executive Chair Ranges & Sofas Certification Fee: 1,00,000.00)",
                  },
                  {
                    heading: "Office Furniture",
                    label:
                      "Office Furniture (Office Desks, Executive Tables Storage (Side & Back Units), Workstation Certification Fee: 1,50,000.00)",
                  },
                  {
                    heading: "Healthcare Furniture",
                    label:
                      "Healthcare Furniture (Bed Side Screen, Cabinet with Drawers & Bed Side Lockers, Examination Table, ICU Beds, Fowler Beds, Hospital Chairs, Benches & Stools, Wheelchair Certification Fee: 1,00,000.00)",
                  },
                  {
                    heading: "Storage Furniture",
                    label:
                      "Storage Furniture (Steel & wooden racks, Cabinets and Almirah with or without sliding & swing doors, Drawer Storage, Locker and Compactor storage systems etc. Certification Fee: 1,00,000.00)",
                  },
                  {
                    heading: "Modular Furniture",
                    label:
                      "Modular Furniture (Sliding wardrobes, walk-in wardrobes, beds with storage, modular study tables, modular display units, and modular entertainment units Certification Fee: 1,00,000.00)",
                  },
                ].map((product, index) => (
                  <div className="product-item" key={index}>
                    <input
                      type="checkbox"
                      id={`product_${index}`}
                      name="range_of_products"
                      value={product.label}
                      checked={formData.range_of_products.some(
                        (p) => p && p.heading === product.heading,
                      )}
                      onChange={handleCheckboxChange}
                      ref={(el) =>
                        (inputRefs.current[`range_of_products_${index}`] = el)
                      }
                      className={errors.range_of_products ? "input-error" : ""}
                    />
                    <label htmlFor={`product_${index}`}>
                      <div className="product-label">{product.label}</div>
                      <div className="product-fees">
                        <span>
                          Certification Fee: ₹
                          {(
                            productMapping[product.label]?.price || 0
                          ).toLocaleString()}
                        </span>
                        <span>Inspection Fee: ₹30,000</span>
                      </div>
                    </label>

                    {/* Dynamic sub-items for all furniture categories */}
                    {formData.range_of_products.some(
                      (p) => p && p.heading === product.heading,
                    ) && (
                      <div className="seating-sub-items-container">
                        <div className="sub-item-input-group">
                          <input
                            type="text"
                            value={subItemInputs[product.heading] || ""}
                            onChange={(e) =>
                              setSubItemInputs((prev) => ({
                                ...prev,
                                [product.heading]: e.target.value,
                              }))
                            }
                            placeholder={`Enter ${product.heading.toLowerCase()} details...`}
                            className="sub-item-input"
                          />
                          <button
                            type="button"
                            onClick={() => addSubItem(product.heading)}
                            className="add-sub-item-btn"
                          >
                            Add
                          </button>
                        </div>
                        <ul className="sub-items-list">
                          {(
                            formData.range_of_products.find(
                              (p) => p && p.heading === product.heading,
                            )?.sub_items || []
                          ).map((sub, subIdx) => (
                            <li key={subIdx} className="sub-item-chip">
                              {sub}
                              <button
                                type="button"
                                onClick={() =>
                                  removeSubItem(product.heading, subIdx)
                                }
                                className="remove-sub-item-btn"
                              >
                                ×
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <h3>Education Furniture</h3>
              <div className="products-list">
                {[
                  {
                    heading: "Classroom Furniture",
                    label:
                      "Classroom furniture(Desk & Seating for different age groups, Teacher's Table and Storage, Certification Fee : 1,00,000.00)",
                    price: 100000,
                  },
                  {
                    heading: "Institutional Furniture",
                    label:
                      "Institutional Furniture( Library, Chemical laboratory & Hostel, Office Desks, Seating System, auditorium, Executive Tables,Board Room, Workstation. Certification Fee : 1,50,000.00)",
                    price: 150000,
                  },
                  {
                    heading: "Classroom and Institutional furniture range",
                    label:
                      "Classroom and Institutional furniture range(Desk & Seating for different age groups, Teacher's Table and Storage, Library, Chemical laboratory & Hostel, Office Desks, Seating System, auditorium, Executive Tables,Board Room, Workstation. Certification Fee : 2,50,000.00)",
                    price: 250000,
                  },
                ].map((product, index) => (
                  <div className="product-item" key={`edu_${index}`}>
                    <input
                      type="checkbox"
                      id={`edu_product_${index}`}
                      name="range_of_products"
                      value={product.label}
                      checked={formData.range_of_products.some(
                        (p) => p && p.heading === product.heading,
                      )}
                      onChange={handleCheckboxChange}
                      ref={(el) =>
                        (inputRefs.current[`edu_product_${index}`] = el)
                      }
                      className={errors.range_of_products ? "input-error" : ""}
                    />
                    <label htmlFor={`edu_product_${index}`}>
                      <div className="product-label">{product.label}</div>
                      <div className="product-fees">
                        <span>
                          Certification Fee: ₹{product.price.toLocaleString()}
                        </span>
                        <span>Inspection Fee: ₹30,000</span>
                      </div>
                    </label>

                    {/* Dynamic sub-items for all education furniture categories */}
                    {formData.range_of_products.some(
                      (p) => p && p.heading === product.heading,
                    ) && (
                      <div className="seating-sub-items-container">
                        <div className="sub-item-input-group">
                          <input
                            type="text"
                            value={subItemInputs[product.heading] || ""}
                            onChange={(e) =>
                              setSubItemInputs((prev) => ({
                                ...prev,
                                [product.heading]: e.target.value,
                              }))
                            }
                            placeholder={`Enter ${product.heading.toLowerCase()} details...`}
                            className="sub-item-input"
                          />
                          <button
                            type="button"
                            onClick={() => addSubItem(product.heading)}
                            className="add-sub-item-btn"
                          >
                            Add
                          </button>
                        </div>
                        <ul className="sub-items-list">
                          {(
                            formData.range_of_products.find(
                              (p) => p && p.heading === product.heading,
                            )?.sub_items || []
                          ).map((sub, subIdx) => (
                            <li key={subIdx} className="sub-item-chip">
                              {sub}
                              <button
                                type="button"
                                onClick={() =>
                                  removeSubItem(product.heading, subIdx)
                                }
                                className="remove-sub-item-btn"
                              >
                                ×
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* <div className="others-specify">
                <h3>Others (Specify)</h3>
                <div className="form-group">
                  <input
                    type="text"
                    name="others_products"
                    value={formData.others_products}
                    onChange={handleInputChange}
                    placeholder="Enter other products (As per specifications and submitted details)"
                    className="others-input"
                    ref={el => inputRefs.current.others_products = el}
                  />
                </div>
              </div> */}

              {/* <div className="others-specify">
                <h3>Others (Specify)</h3>
                <div className="form-group">
                  <input
                    type="text"
                    name="others_products"
                    value={formData.others_products}
                    onChange={handleInputChange}
                    placeholder="Enter other products (As per specifications and submitted details)"
                    className="others-input"
                    ref={el => inputRefs.current.others_products = el}
                  />
                </div>
              </div> */}
              <div className="manufacturing-section">
                <h3>Manufacturing Facilities:</h3>

                <div className="subsection">
                  <h4 className="text-start">Area of Factory:</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Total Plot / Land Area: Sq. Ft{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="plot"
                        value={formData.plot}
                        onChange={handleInputChange}
                        placeholder="Enter Total Plot / Land Area: Sq. Ft"
                        ref={(el) => (inputRefs.current.plot = el)}
                        className={errors.plot ? "input-error" : ""}
                        required
                      />
                      {errors.plot && (
                        <span className="error">{errors.plot}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Production Shed: Sq. Ft{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="production_shed"
                        value={formData.production_shed}
                        onChange={handleInputChange}
                        placeholder="Enter Production Shed Sq. Ft"
                        ref={(el) => (inputRefs.current.production_shed = el)}
                        className={errors.production_shed ? "input-error" : ""}
                        required
                      />
                      {errors.production_shed && (
                        <span className="error">{errors.production_shed}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Total Covered Area: Sq. Ft{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="total_area"
                        value={formData.total_area}
                        onChange={handleInputChange}
                        placeholder="Enter Total Covered Area Sq. Ft"
                        ref={(el) => (inputRefs.current.total_area = el)}
                        className={errors.total_area ? "input-error" : ""}
                        required
                      />
                      {errors.total_area && (
                        <span className="error">{errors.total_area}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Administrative Area: Sq. Ft{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="administartive_area"
                        value={formData.administartive_area}
                        onChange={handleInputChange}
                        placeholder="Enter Administrative Area Sq. Ft"
                        ref={(el) =>
                          (inputRefs.current.administartive_area = el)
                        }
                        className={
                          errors.administartive_area ? "input-error" : ""
                        }
                        required
                      />
                      {errors.administartive_area && (
                        <span className="error">
                          {errors.administartive_area}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="subsection">
                  <h4 className="text-start">Electric Power:</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Domestic /Commercial / Industrial:{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="domestic_commercial"
                        value={formData.domestic_commercial}
                        onChange={handleInputChange}
                        placeholder="Enter Domestic /Commercial / Industrial"
                        ref={(el) =>
                          (inputRefs.current.domestic_commercial = el)
                        }
                        className={
                          errors.domestic_commercial ? "input-error" : ""
                        }
                        required
                      />
                      {errors.domestic_commercial && (
                        <span className="error">
                          {errors.domestic_commercial}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Sanctioned Power Load (kW/kVA){" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="power_load"
                        value={formData.power_load}
                        onChange={handleInputChange}
                        placeholder="Enter Sanctioned Power Load (e.g., 100 kW or 150 kVA)"
                        ref={(el) => (inputRefs.current.power_load = el)}
                        className={errors.power_load ? "input-error" : ""}
                        required
                      />
                      {errors.power_load && (
                        <span className="error">{errors.power_load}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="subsection">
                  <h4 className="text-start">
                    Manufacturing Registration Certificate Issued As:{" "}
                    <span className="required-asterisk">*</span>
                  </h4>
                  <div className="checkbox-row">
                    <label>
                      <input
                        type="checkbox"
                        className="mt-0"
                        name="certificate_issued_micro_small"
                        checked={formData.certificate_issued === "Micro/Small"}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFormData((prev) => ({
                            ...prev,
                            certificate_issued: isChecked ? "Micro/Small" : "",
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            certificate_issued: "",
                          }));
                        }}
                        ref={(el) =>
                          (inputRefs.current.certificate_issued_micro_small =
                            el)
                        }
                      />{" "}
                      Micro/Small
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        className="mt-0"
                        name="certificate_issued_medium_large"
                        checked={formData.certificate_issued === "Medium/Large"}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFormData((prev) => ({
                            ...prev,
                            certificate_issued: isChecked ? "Medium/Large" : "",
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            certificate_issued: "",
                          }));
                        }}
                        ref={(el) =>
                          (inputRefs.current.certificate_issued_medium_large =
                            el)
                        }
                      />{" "}
                      Medium/Large
                    </label>
                  </div>
                  {errors.certificate_issued && (
                    <span className="error">{errors.certificate_issued}</span>
                  )}

                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Available Certificates [ISO, Green Guard, BFMA and
                        Equivalent others]:{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="available_certificate"
                        value={formData.available_certificate}
                        onChange={handleInputChange}
                        placeholder="Enter Available Certificates"
                        ref={(el) =>
                          (inputRefs.current.available_certificate = el)
                        }
                        className={
                          errors.available_certificate ? "input-error" : ""
                        }
                        required
                      />
                      {errors.available_certificate && (
                        <span className="error">
                          {errors.available_certificate}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        The Annual Turnover (Last Three Years) for Manufacturing
                        Furniture: <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="annual_turnover"
                        value={formData.annual_turnover}
                        onChange={handleInputChange}
                        placeholder="Enter The Annual Turnover"
                        ref={(el) => (inputRefs.current.annual_turnover = el)}
                        className={errors.annual_turnover ? "input-error" : ""}
                        required
                      />
                      {errors.annual_turnover && (
                        <span className="error">{errors.annual_turnover}</span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Date of Application:{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="date_application"
                        value={formData.date_application}
                        onChange={handleInputChange}
                        ref={(el) => (inputRefs.current.date_application = el)}
                        className={errors.date_application ? "input-error" : ""}
                        max={new Date().toISOString().split("T")[0]}
                        required
                      />
                      {errors.date_application && (
                        <span className="error">{errors.date_application}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Name: <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter Name"
                        ref={(el) => (inputRefs.current.name = el)}
                        className={errors.name ? "input-error" : ""}
                        required
                      />
                      {errors.name && (
                        <span className="error">{errors.name}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Designation:{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="designation"
                        value={formData.designation}
                        onChange={handleInputChange}
                        placeholder="Enter Designation"
                        ref={(el) => (inputRefs.current.designation = el)}
                        className={errors.designation ? "input-error" : ""}
                        required
                      />
                      {errors.designation && (
                        <span className="error">{errors.designation}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <h3>Note: </h3>
              <div className="notes-section">
                <ul style={{ marginBottom: "15px", paddingLeft: "25px" }}>
                  <li style={{ marginBottom: "10px" }}>
                    All columns should necessarily be filled.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    The documents/information desired by the duly appointed
                    Inspection Committee should be submitted as and when will be
                    required.
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    The incomplete/unreadable information and applicants not
                    fulfilling the criterion specified in the Request Form shall
                    be liable for rejection.
                  </li>
                </ul>
              </div>

              {/* <div className="self-attested-section">
                <h3>
                  Self-Attested Scanned copy of Documents in Hard Copies to be
                  sent to:
                </h3>
                <p>Dr. Pratibha M. v</p>
                <p>Convener</p>
                <p>AIOTA Ergonomic Design Certification Committee</p>
                <p>Flat No: EIQ, Pranam Society,</p>
                <p>Plot No. 513, Shimpoli Link Road,</p>
                <p>Borivail West, Mumbai,</p>
                <p>Maharashtra – 400092</p>
                <p>Mobile: 9821536404</p>
                <p>E-Mail ID: pmv25@rediffmail.com</p>
              </div> */}

              <div className="document-upload-section">
                <div className="document-note">
                  <p>
                    Please note: Allowed formats for Certificates and Documents:
                    PDF, Max Size: 10MB. Please ensure that the PDF files are in
                    plain PDF format and the file is not password protected.
                  </p>
                </div>

                {[
                  {
                    field: "details_of_machineries",
                    label:
                      "List of products manufactured(A separate list of products should be clearly specified for each category and provided on the company letterhead, duly sealed and signed.)",
                  },
                  {
                    field: "lease_agreement",
                    label:
                      "Registry document/Lease Agreement (verifying total area & covered area)",
                  },
                  {
                    field: "electricity_bill",
                    label:
                      "Copy of latest/last three-month electricity bill in the name of the manufacturing plant of the firm",
                  },
                  {
                    field: "gst_certificate",
                    label: "Copy of GST Registration Certificate",
                  },
                  {
                    field: "pan_certificate",
                    label: "Copy of PAN Number Registration certificate",
                  },
                  {
                    field: "acknowledgement_certificate",
                    label:
                      "Copy of Acknowledgement EM Part-II/Udyog Aadhar Memorandum issued by the Industries Department in case of Micro/Small Units",
                  },
                  {
                    field: "unit_registration_certificate",
                    label:
                      "Copy of Unit Registration Certificate by any other Statutory Competent Authority for Manufacturing of the Furniture in case of Medium/large Units",
                  },
                  {
                    field: "ca_certificate",
                    label:
                      "Copy of CA Certificate as proof of the Balance Sheet for last three years",
                  },
                  {
                    field: "copy_certificates",
                    label:
                      "Copy of Other Certificates (ISO, BFMA, Green Guard and Equivalent others)",
                  },
                  {
                    field: "list_of_machines",
                    label:
                      "List of Machines used in manufacturing of the furniture and testing equipment on letterhead with seal and signature",
                  },
                  {
                    field: "company_seal",
                    label: "Company Seal",
                  },
                  {
                    field: "upload_signature",
                    label: "Upload Signature",
                  },
                  {
                    field: "affidavit",
                    label:
                      "Affidavit on Stamp Paper– Clearly stating that all the information provided in the Request Form for AIOTA's Ergonomic Certification is true",
                  },
                  {
                    field: "signed_letter_head",
                    label:
                      "Official Letterhead with duly signed and stamped undertaking by the Chairman/Proprietor/Director stating that the products to be presented for inspection for AIOTA Ergonomic Certification are actually produced by the company/firm. (Specify the name and place of the Industry/Company/Firm.)",
                  },
                ].map((doc, index) => (
                  <div className="document-row" key={index}>
                    <div className="label-with-error">
                      <p>
                        {doc.label} <span className="required-asterisk">*</span>
                      </p>
                      {errors[doc.field] && (
                        <span className="error">
                          <span className="error-icon">⚠️</span>{" "}
                          {errors[doc.field]}
                        </span>
                      )}
                    </div>
                    <div className="file-upload-row">
                      <input
                        type="file"
                        id={`doc_${index}`}
                        className={`file-input${
                          errors[doc.field] ? " input-error" : ""
                        }`}
                        onChange={(e) => handleFileChange(e, doc.field)}
                        ref={(el) => (inputRefs.current[doc.field] = el)}
                        required
                      />
                      <label
                        htmlFor={`doc_${index}`}
                        className="file-upload-button"
                      >
                        Choose File
                      </label>
                      <span
                        className={`file-status ${formData[doc.field] ? "file-uploaded" : ""}`}
                      >
                        {formData[doc.field]
                          ? shortenFileName(formData[doc.field].name)
                          : "No File Chosen"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="buttons">
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationForm;
